/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleEnum } from './RoleEnum';
import {
    RoleEnumFromJSON,
    RoleEnumFromJSONTyped,
    RoleEnumToJSON,
    RoleEnumToJSONTyped,
} from './RoleEnum';

/**
 *
 * @export
 * @interface MembershipRole
 */
export interface MembershipRole {
    /**
     *
     * @type {RoleEnum}
     * @memberof MembershipRole
     */
    role: RoleEnum;
}



/**
 * Check if a given object implements the MembershipRole interface.
 */
export function instanceOfMembershipRole(value: object): value is MembershipRole {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function MembershipRoleFromJSON(json: any): MembershipRole {
    return MembershipRoleFromJSONTyped(json, false);
}

export function MembershipRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): MembershipRole {
    if (json == null) {
        return json;
    }
    return {

        'role': RoleEnumFromJSON(json['role']),
    };
}

  export function MembershipRoleToJSON(json: any): MembershipRole {
      return MembershipRoleToJSONTyped(json, false);
  }

  export function MembershipRoleToJSONTyped(value?: MembershipRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'role': RoleEnumToJSON(value['role']),
    };
}
